<template>
  <div
    class="
      tw-flex
      tw-items-center
      tw-justify-center
      tw-uppercase
      tw-rounded-md
      tw-size-6
      tw-shrink-0
      tw-text-center
      tw-text-[10px]
      tw-leading-none
      tw-font-medium
    "
    :class="avatarClasses"
  >
    {{ abbreviatedName }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { abbreviate } from './utils.js'

interface Props {
  active: boolean
  text: string
  abbreviation?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  active: false,
  text: '',
  abbreviation: null,
})

const avatarClasses = computed(() => {
  return {
    'tw-bg-sf-primary': props.active,
    'tw-text-sf-snow-lighter': props.active,
    'tw-bg-sf-slate-subtle-2': !props.active,
    'tw-text-sf-slate-light-2': !props.active,
    'tw-border': !props.active,
    'tw-border-sf-slate-lighter-1': !props.active,
    'tw-border-solid': !props.active,
    'hover:tw-border-solid': !props.active,
    'hover:tw-cursor-pointer': !props.active,
    'hover:tw-bg-sf-primary-subtle': !props.active,
    'hover:tw-border-sf-primary-dark': !props.active,
    'hover:tw-text-sf-primary-dark': !props.active,
    'group-hover:tw-border-solid': !props.active,
    'group-hover:tw-cursor-pointer': !props.active,
    'group-hover:tw-bg-sf-primary-subtle': !props.active,
    'group-hover:tw-border-sf-primary-dark': !props.active,
    'group-hover:tw-text-sf-primary-dark': !props.active,
  }
})

const abbreviatedName = computed(
  () => props.abbreviation?.trim() || abbreviate(props.text)
)
</script>
